var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-contain"},[_vm._v(" 兰溪市安程人力资源有限公司 Copyright © lxrcsc.net ")])])
}]

export { render, staticRenderFns }